/** @format */

import { ThemeProvider } from "./components/theme-provider";
import { SessionProvider } from "./context/SessionContext";
import Settings from "./pages/Assistant";
import { Toaster } from "react-hot-toast";
import { useEffect, useState } from "react";
import { t } from "i18next";

function App() {
  const [selectedUserPhone, setSelectedUserPhone] = useState<string | null>(
    null
  )

  const handleUserSelect = (phone: string) => {
    setSelectedUserPhone(phone);
  };


  const updateFaviconAndTitle = () => {
    const faviconLink: any = document.querySelector('link[rel="icon"]');

    // Listas de URLs
    const isVeterinarian = process.env.REACT_APP_ENV === "veterinarian"

    if (isVeterinarian) {
      faviconLink.href = "/faviconVet.svg";
      document.title = t("omnivet");
    }

  };

  useEffect(() => {
    updateFaviconAndTitle()
  }, []);

  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          // Define default options
          className: "",
          duration: 5000,
          style: {
            background: "#363636",
            color: "#fff",
          },

          // Default options for specific types
          success: {
            duration: 3000,
          },
        }}
      />
      <SessionProvider>
        <div className="min-h-screen bg-background font-sans antialiased">
            <Settings />
        </div>
      </SessionProvider>
    </ThemeProvider>
  );
}

export default App;
